import { supabase } from '../config/supabaseConfig.ts';

const ASSISTANT_COLS = ['assistant_text_turns_monthly', 'assistant_voice_minutes_monthly', 'assistant_cost_cap_usd_monthly'];
const withoutAssistant = (o) => Object.fromEntries(Object.entries(o).filter(([k]) => !ASSISTANT_COLS.includes(k)));
// Si el script 50 todavía no está aplicado, las columnas del asistente no existen: se guarda el plan sin ellas
const missingAssistantCols = (error) => /assistant_(text_turns|voice_minutes|cost_cap)|schema cache/i.test(error?.message || '');

export const planService = {
  getAll: async (onlyActive = false) => {
    let q = supabase.from('plans').select('*').order('name');
    if (onlyActive) q = q.eq('is_active', true);
    const { data, error } = await q;
    if (error) throw error;
    return data || [];
  },

  // Devuelve { [plan_id]: count } con número de usuarios por plan
  getUserCounts: async () => {
    const { data, error } = await supabase
      .from('user_settings')
      .select('plan_id');
    if (error) throw error;
    const counts = {};
    (data || []).forEach(s => {
      if (s.plan_id) counts[s.plan_id] = (counts[s.plan_id] || 0) + 1;
    });
    return counts;
  },

  // Los topes del asistente (por mes, script 50) son opcionales: null = sin tope. `plan` viene de utils/assistantPlans.planCaps
  create: async (plan) => {
    const { data, error } = await supabase.from('plans').insert({ ...plan, is_active: true }).select().single();
    if (error && missingAssistantCols(error)) {
      const retry = await supabase.from('plans').insert({ ...withoutAssistant(plan), is_active: true }).select().single();
      if (retry.error) throw retry.error;
      return retry.data;
    }
    if (error) throw error;
    return data;
  },

  update: async (id, updates) => {
    const { data, error } = await supabase
      .from('plans')
      .update(updates)
      .eq('id', id)
      .select()
      .single();
    if (error && missingAssistantCols(error)) {
      const retry = await supabase.from('plans').update(withoutAssistant(updates)).eq('id', id).select().single();
      if (retry.error) throw retry.error;
      return retry.data;
    }
    if (error) throw error;
    return data;
  },

  deactivate: async (id) => {
    const { error } = await supabase
      .from('plans')
      .update({ is_active: false })
      .eq('id', id);
    if (error) throw error;
  },
};
